<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: this.$tApp('nav.home') }}].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    /* 改 inline-flex + max-width:100% + overflow:hidden, 让面包屑能在 navbar 收窄时
       不撑破父容器. 每个 item 单独 ellipsis 截断, 超长菜单名显示为「公告管... / ...」. */
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    overflow: hidden;
    font-size: 13px;
    line-height: var(--nav-height, 50px);
    margin-left: 4px;
    font-weight: 500;
    letter-spacing: 0.01em;
    ::v-deep .el-breadcrumb__separator {
      color: var(--text-muted);
      font-weight: 400;
      flex-shrink: 0;
    }
    ::v-deep .el-breadcrumb__item {
      display: inline-flex;
      align-items: center;
      overflow: hidden;
    }
    ::v-deep .el-breadcrumb__inner,
    ::v-deep .el-breadcrumb__inner a,
    ::v-deep .no-redirect {
      max-width: 220px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      vertical-align: bottom;
    }
    ::v-deep a {
      color: var(--text-secondary);
      transition: color 0.15s ease;
    }
    ::v-deep a:hover {
      color: #2563eb;
    }
    .no-redirect {
      color: var(--text-primary);
      cursor: default;
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue